<script setup lang="ts">
/** AGM 문서 공통 머리말: 회사명 / Registration No. / (Incorporated …) / (the “Company”) [/ Registered Office]. */
import CddVarField from '../../../preset/components/final-dividends/cdd/CddVarField.vue';

defineProps<{ registeredOffice?: boolean }>();
</script>

<template>
  <div class="doc-head">
    <div class="doc-title"><CddVarField field-key="company_name" label="Company Name" /></div>
    <div class="doc-sub">Registration No. <CddVarField field-key="company_registration_no" label="Registration No." /></div>
    <div class="doc-sub">(Incorporated in the Republic of Singapore)</div>
    <div class="doc-sub">(the &ldquo;Company&rdquo;)</div>
    <div v-if="registeredOffice" class="doc-sub">Registered Office: <CddVarField field-key="registered_office_address" label="Registered Office" /></div>
  </div>
</template>
